import React, { Component} from "react";
import {Auth} from "aws-amplify";
import {Link, NavLink, withRouter} from "react-router-dom";
import Routes from "./Routes";
import {currentTimeMs, saveProsQueryString, setLatestSigoutError} from "./prodect/ProsConnect";
import {clearByLogout, prosLog, prosLogX} from "./prodect/ProsConnect"
import {USE_DEVELOPMENT_FEATURES} from "./config";

var gloProdectApp
// var gloIsTouchMode = false//Will be enabled later
export async function handleSessionException() {
    await gloProdectApp.handleLogout(false)
}

export async function appProdectLogout(why) {
    let clearAllSettings = false
    if (why) {
        setLatestSigoutError(why)
        prosLogX("Log out reason", why)
        clearAllSettings = true
    }
    await gloProdectApp.handleLogout(clearAllSettings)
}

export async function refreshSession() {
    try {
        const cognitoUser = await Auth.currentAuthenticatedUser()
        // idToken, refreshToken, accessToken
        const { refreshToken, accessToken } = cognitoUser.getSignInUserSession()
        const SESSION_EXPIRES_SEC = Math.floor(currentTimeMs() / 1000) - (60*10)
        if (accessToken && accessToken.payload && accessToken.payload.exp < SESSION_EXPIRES_SEC) {
            cognitoUser.refreshSession(refreshToken, (err, session) => {
                prosLog("App/refreshSession()")
                if (USE_DEVELOPMENT_FEATURES) {
                    console.log('cognitoUser.refreshSession', err, session)
                }
            })
        }
    } catch (e) {
        prosLogX("Unable to refresh token:", e)
        await appProdectLogout('session refresh failed')
    }
}

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            isAuthenticating: true
        };
        gloProdectApp = this
        //Will be enabled later
        // if(window.matchMedia("(pointer: coarse)").matches) {
        //     gloIsTouchMode = true
        // }
    }

    async componentDidMount() {
        prosLog("App:componentDidMount()");
        saveProsQueryString(this.props.location.search);
        try {
            await Auth.currentSession();
            this.userHasAuthenticated(true);
        }
        catch(e) {
            // if (e.message && e.message !== 'No current user') {
            prosLogX("App:componentDidMount() exception:", e);
            // handleSessionException('app start')
            // } else { prosLogX("Prodect - user not logged in")}
        }
        this.setState({ isAuthenticating: false })
        //Will be enabled later
        // if(gloIsTouchMode){
        //     document.body.classList.add("touch")
        // }
    }

    componentWillUnmount() {
        prosLog("App::componentWillUnmount() --");
    }

    userHasAuthenticated = authenticated => {
        prosLog("App - authenticated:", this.props.isAuthenticated);
        this.setState({ isAuthenticated: authenticated });
    };

    handleLogout = async clearAllSettings => {
        clearByLogout("clearAllSettings");
        await Auth.signOut();
        this.userHasAuthenticated(false);
        //this.props.history.push("/authLogin");
    };

    render() {
        const childProps = {
            isAuthenticated: this.state.isAuthenticated,
            userHasAuthenticated: this.userHasAuthenticated,
            handleLogout: this.handleLogout
        };

        if (this.state.isAuthenticating) {
            return <div className={"mini-page"}><header><h1>Kirjautuminen kesken...</h1></header></div>
        }
        return (
            <>
                {this.state.isAuthenticated
                    ? ""
                    :
                <nav className={"start-pages"}>
                    <Link className={"logo dom-hide dom-show_lg"} to="/" title={"Etusivu"}>
                        <img className={"dom-hide_lg"} src={"/images/prodect.svg"} alt={"Prodect-logo"}/>
                        <img className={"dom-hide dom-show-block_lg"} src={"/images/prodect-text.svg"} alt={"Prodect-logo"}/>
                    </Link>
                    <ul>
                        {this.state.isAuthenticated
                            ? <>
                                <li>
                                    <NavLink to="/">Etusivu</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/settings">Asetukset</NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={this.handleLogout}>Kirjaudu ulos</NavLink>
                                </li>
                            </>
                            :
                            <>
                                <li>
                                    <NavLink to="/authForgotPwd">Unohdin salasanan</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/authLogin">Kirjautuminen</NavLink>
                                </li>
                                 <li>
                                     <NavLink to="/authSignup" className={"btn btn-2nd"}><span>Rekisteröidy</span></NavLink>
                                 </li>
                            </>}
                    </ul>
                </nav>
                }
                <Routes childProps={childProps} />
            </>
        )
    }
}

export default withRouter(App);
